<div class="p-3 pt-2 rounded-4">
  <div>
    <div class="pTitle border-0 mb-0 rounded-bottom-0 rounded-4 p-0 d-flex justify-content-between">
      <div class="p-3">ESIM Packages</div>
    </div>
  </div>
  <div class="container-fluid">
    <div class="row bg-white p-2 pt-0">
      <div class="col-12 mt-4 mb-5">
        <!-- Country selection form -->
        <div class="row mb-4">
          <div class="col-md-4">
            <div class="form-group">
              <label for="countrySelect">Select Country:</label>
              <select
                id="countrySelect"
                class="form-control"
                [(ngModel)]="selectedCountryCode"
                (change)="onCountryChange($event)">
                <option value="">-- Select a Country --</option>
                @for (country of countries; track country) {
                  <option [value]="country.country_code">
                    {{ country.displayName }} ({{ country.country_code }})
                  </option>
                }
              </select>
            </div>
          </div>
          <div class="col-md-2">
            <button
              class="btn btn-primary mt-4"
              (click)="submitCountry()"
              [disabled]="!selectedCountryCode || loading">
              Load Packages
            </button>
          </div>
        </div>

        <!-- Error message -->
        @if (error && !loading) {
          <div class="alert alert-danger mt-3">
            {{ error }}
          </div>
        }

        <!-- Loading indicator -->
        @if (loading) {
          <div class="d-flex justify-content-center mt-5">
            <div class="spinner-border" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
        }

        <!-- Display operator buttons if no operator is selected -->
        @if (!loading && !error && packages.length > 0 && !selectedOperator) {
          <div class="mt-4">
            <h4>Available Operators</h4>
            <div class="row">
              @for (pkgCountry of packages; track trackByPackageCountry($index, pkgCountry)) {
                <div class="col-12">
                  @for (operator of pkgCountry.operators; track trackByOperator($index, operator)) {
                    <div class="card mb-3 operator-card"
                      [style.background]="'linear-gradient(to right, ' + operator.gradient_start + ', ' + operator.gradient_end + ')'"
                      style="color: white; cursor: pointer;" (click)="showOperatorPackages(operator)">
                      <div class="card-body">
                        <div class="d-flex align-items-center mb-2">
                          <img [src]="operator.image.url" class="operator-image me-3"
                            style="width: 60px; height: 60px; object-fit: cover; border-radius: 5px;">
                          <div>
                            <h5 class="card-title mb-1">{{ operator.title }}</h5>
                            <p class="card-text mb-1">{{ operator.esim_type }} - {{ operator.plan_type | uppercase }}</p>
                            <small>{{ operator.packages.length }} packages available</small>
                          </div>
                        </div>
                        <!-- Operator details -->
                        <div class="operator-details mt-2">
                          <div class="row">
                            <div class="col-md-6">
                              <small><strong>Type:</strong> {{ operator.type }}</small><br>
                              <small><strong>Prepaid:</strong> {{ operator.is_prepaid ? 'Yes' : 'No' }}</small><br>
                              <small><strong>Roaming:</strong> {{ operator.is_roaming ? 'Yes' : 'No' }}</small><br>
                              <small><strong>Rechargeable:</strong> {{ operator.rechargeability ? 'Yes' : 'No' }}</small>
                            </div>
                            <div class="col-md-6">
                              <small><strong>Activation:</strong> {{ operator.activation_policy }}</small><br>
                              <small><strong>Install Window:</strong> {{ operator.install_window_days }} days</small><br>
                              <small><strong>Top-up Grace:</strong> {{ operator.topup_grace_window_days }} days</small>
                            </div>
                          </div>
                          <!-- Info list -->
                          @if (operator.info && operator.info.length > 0) {
                            <div class="mt-2">
                              <small class="d-block"><strong>Info:</strong></small>
                              <ul class="list-unstyled mb-0" style="font-size: 0.85rem;">
                                @for (info of operator.info; track info) {
                                  <li class="d-flex">
                                    <span class="me-1">•</span> {{ info }}
                                  </li>
                                }
                              </ul>
                            </div>
                          }
                        </div>
                      </div>
                    </div>
                  }
                </div>
              }
            </div>
          </div>
        }

        <!-- Display packages table if an operator is selected -->
        @if (!loading && !error && selectedOperator) {
          <div class="mt-4">
            <button class="btn btn-secondary mb-3" (click)="goBackToOperators()">
              <i class="fas fa-arrow-left me-1"></i> Back to Operators
            </button>
            <div class="card">
              <div class="card-header"
                [style.background]="'linear-gradient(to right, ' + selectedOperator.gradient_start + ', ' + selectedOperator.gradient_end + ')'"
                style="color: white;">
                <div class="d-flex align-items-center">
                  <img [src]="selectedOperator.image.url" class="operator-image me-3"
                    style="width: 50px; height: 50px; object-fit: cover; border-radius: 5px;">
                  <div>
                    <h4 class="mb-0">{{ selectedOperator.title }}</h4>
                    <small>{{ selectedOperator.packages.length }} packages available</small>
                  </div>
                </div>
              </div>
              <!-- Operator details section -->
              <div class="card-body">
                <div class="row mb-4">
                  <div class="col-md-6">
                    <h6>Operator Details</h6>
                    <table class="table table-sm table-borderless">
                      <tr>
                        <td><strong>Type:</strong></td>
                        <td>{{ selectedOperator.type }}</td>
                      </tr>
                      <tr>
                        <td><strong>ESIM Type:</strong></td>
                        <td>{{ selectedOperator.esim_type }}</td>
                      </tr>
                      <tr>
                        <td><strong>Prepaid:</strong></td>
                        <td>{{ selectedOperator.is_prepaid ? 'Yes' : 'No' }}</td>
                      </tr>
                      <tr>
                        <td><strong>Roaming:</strong></td>
                        <td>{{ selectedOperator.is_roaming ? 'Yes' : 'No' }}</td>
                      </tr>
                      <tr>
                        <td><strong>Rechargeable:</strong></td>
                        <td>{{ selectedOperator.rechargeability ? 'Yes' : 'No' }}</td>
                      </tr>
                      <tr>
                        <td><strong>Activation Policy:</strong></td>
                        <td>{{ selectedOperator.activation_policy }}</td>
                      </tr>
                      <tr>
                        <td><strong>Install Window:</strong></td>
                        <td>{{ selectedOperator.install_window_days }} days</td>
                      </tr>
                      <tr>
                        <td><strong>Top-up Grace Window:</strong></td>
                        <td>{{ selectedOperator.topup_grace_window_days }} days</td>
                      </tr>
                      <tr>
                        <td><strong>APN Type:</strong></td>
                        <td>{{ selectedOperator.apn_type }}</td>
                      </tr>
                      <tr>
                        <td><strong>APN Value:</strong></td>
                        <td>{{ selectedOperator.apn_value }}</td>
                      </tr>
                    </table>
                  </div>
                  <div class="col-md-6">
                    <h6>Network Information</h6>
                    @if (selectedOperator.coverages && selectedOperator.coverages.length > 0) {
                      <div>
                        @for (coverage of selectedOperator.coverages; track coverage) {
                          <div>
                            <p><strong>Coverage:</strong> {{ coverage.name }} ({{ coverage.code }})</p>
                            @for (network of coverage.networks; track network) {
                              <div>
                                <p class="mb-1"><strong>Network:</strong> {{ network.name }}</p>
                                <p class="text-muted"><strong>Types:</strong> {{ network.types.join(', ') }}</p>
                              </div>
                            }
                          </div>
                        }
                      </div>
                    }
                    <h6 class="mt-3">APN Settings</h6>
                    <div class="row">
                      <div class="col-6">
                        <p class="mb-1"><strong>iOS:</strong></p>
                        <p class="text-muted mb-0">Type: {{ selectedOperator.apn.ios.apn_type }}</p>
                        <p class="text-muted mb-0">Value: {{ selectedOperator.apn.ios.apn_value }}</p>
                      </div>
                      <div class="col-6">
                        <p class="mb-1"><strong>Android:</strong></p>
                        <p class="text-muted mb-0">Type: {{ selectedOperator.apn.android.apn_type }}</p>
                        <p class="text-muted mb-0">Value: {{ selectedOperator.apn.android.apn_value }}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Additional operator information -->
                @if (selectedOperator.info && selectedOperator.info.length > 0) {
                  <div class="row mb-4">
                    <div class="col-12">
                      <h6>Info</h6>
                      <ul class="list-unstyled">
                        @for (info of selectedOperator.info; track info) {
                          <li class="mb-1">
                            <span class="me-2">•</span>{{ info }}
                          </li>
                        }
                      </ul>
                    </div>
                  </div>
                }
                @if (selectedOperator.other_info) {
                  <div class="row mb-4">
                    <div class="col-12">
                      <h6>Other Information</h6>
                      <p>{{ selectedOperator.other_info }}</p>
                    </div>
                  </div>
                }
                <!-- Packages table -->
                <h6>Packages</h6>
                <div class="table-responsive">
                  <table class="table table-striped">
                    <thead>
                      <tr>
                        <th>ID</th>
                        <th>Title</th>
                        <th>Data</th>
                        <th>Amount (MB)</th>
                        <th>Duration (days)</th>
                        <th>Price (USD)</th>
                        <th>Type</th>
                        <th>Unlimited</th>
                        <th>Voice</th>
                        <th>Text</th>
                        <th>Fair Usage Policy</th>
                      </tr>
                    </thead>
                    <tbody>
                      @for (pkg of displayedPackages; track trackByPackage($index, pkg)) {
                        <tr>
                          <td>{{ pkg.id }}</td>
                          <td>
                            <strong>{{ pkg.title }}</strong>
                            @if (pkg.short_info) {
                              <div class="text-muted small">{{ pkg.short_info }}</div>
                            }
                          </td>
                          <td>
                            @if (!pkg.is_unlimited) {
                              <span class="badge bg-primary">{{ pkg.data }}</span>
                            }
                            @if (pkg.is_unlimited) {
                              <span class="badge bg-success">Unlimited</span>
                            }
                          </td>
                          <td>{{ pkg.amount }}</td>
                          <td>{{ pkg.day }}</td>
                          <td>{{ pkg.price }}</td>
                          <td>{{ pkg.type }}</td>
                          <td>
                            <span class="badge" [class.bg-success]="pkg.is_unlimited" [class.bg-warning]="!pkg.is_unlimited">
                              {{ pkg.is_unlimited ? 'Yes' : 'No' }}
                            </span>
                          </td>
                          <td>{{ pkg.voice || 'N/A' }}</td>
                          <td>{{ pkg.text || 'N/A' }}</td>
                          <td>
                            @if (pkg.is_fair_usage_policy && pkg.fair_usage_policy) {
                              <span class="text-warning">
                                {{ pkg.fair_usage_policy }}
                              </span>
                            }
                            @if (!pkg.is_fair_usage_policy || !pkg.fair_usage_policy) {
                              <span>None</span>
                            }
                          </td>
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        }

        <!-- No packages message -->
        @if (!loading && !error && packages.length === 0 && selectedCountryCode) {
          <div class="alert alert-info mt-3">
            No packages available for the selected country.
          </div>
        }

        <!-- No country selected message -->
        @if (!selectedCountryCode && !loading && !error) {
          <div class="alert alert-info mt-3">
            Please select a country and click "Load Packages" to view available packages.
          </div>
        }
      </div>
    </div>
  </div>
</div>